<template>
  <div>
    <h2 class="step-name">Dairy Support</h2>

    <discussion-points
      title="Discussion Points"
      comments-field="dairy_support_discussion"
      points="who do you graze for, biosecurity discussion"
    >
    </discussion-points>

    <discussion-points
      title=""
      comments-field="dairy_support_has_animal_health_treatments_discussion"
      points="BVD Vax, Copper"
    >
      <radio-input
        label="Do you manage the animal health treatments?"
        field-name="dairy_support_has_animal_health_treatments"
        :choices="[
          { value: 'Yes', display: 'Yes' },
          { value: 'No', display: 'No' },
        ]"
        :add-comment="true"
      >
      </radio-input>
    </discussion-points>

    <discussion-points
      title=""
      comments-field="dairy_support_wants_animal_health_plan_discussion"
      points="Entry/exit date, mating, bull synchro"
    >
      <radio-input
        label="Do you want an animal health plan for your dairy support?"
        field-name="dairy_support_wants_animal_health_plan"
        :choices="[
          { value: 'Yes', display: 'Yes' },
          { value: 'No', display: 'No' },
        ]"
        :add-comment="true"
      >
      </radio-input>
    </discussion-points>
  </div>
</template>

<script>
import baseComponent from '@/mixins/base_consult_component_v2'

export default {
  name: 'DairySupport',
  mixins: [baseComponent],
}
</script>
